import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { AppSettingService } from "src/services/app-setting/app-setting.service";
import { AuthService } from "src/services/auth/auth.service";
import { Meta } from "@angular/platform-browser";
import { ArticleService } from "src/services/article/article.service";
import { ArticleModel } from "src/models/article.model";
import { RequestType } from "src/models/request-type";
import { RequestTypeService } from "src/services/request-type/request-type.service";
import { Services } from "src/models/services";
import { ServicesService } from "src/services/services/services.service";

import { Chart, registerables } from "chart.js";
import { numberWithSpaces, startCounting } from "src/utils/utils";
import { retryWhen, delay, take, tap, mergeMap } from "rxjs/operators";
import { of, throwError } from "rxjs";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  articles: Array<ArticleModel>;
  requestTypes: RequestType;
  services: Array<Services>;
  loading: boolean = true;

  count: number = 0;
  speed: number = 1; // 1 pour lent, peut être augmenté pour accélérer
  intervalId: any;
  target: number = 0;

  count1: number = 0;
  speed1: number = 1; // 1 pour lent, peut être augmenté pour accélérer
  intervalId1: any;
  target1: number = 0;

  constructor(
    private authService: AuthService,
    private router: Router,
    private jwtHelper: JwtHelperService,
    public appSettingService: AppSettingService,
    private meta: Meta,
    private articleService: ArticleService,
    private typeRequestService: RequestTypeService,
    private serviceService: ServicesService
  ) {
    Chart.register(...registerables);
  }

  getStats(appSetting: any) {
    new Chart("myChart1", {
      type: "line",
      data: {
        labels: appSetting.companies_by_year.series.name,
        datasets: [
          {
            label: appSetting.companies_by_year.name,
            data: appSetting.companies_by_year.series.value,
            borderWidth: 2,
            backgroundColor: "#00533e",
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });

    // new Chart("myChart2", {
    //     type: "line",
    //     data: {
    //         labels: ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    //         datasets: [
    //             {
    //                 label: "Nombre de PME/PMI benchmarchées",
    //                 data: [12, 19, 3, 5, 2, 3, 50],
    //                 borderWidth: 2,
    //                 backgroundColor: "#00533e",
    //             },
    //         ],
    //     },
    //     options: {
    //         scales: {
    //             y: {
    //                 beginAtZero: true,
    //             },
    //         },
    //     },
    // });

    // new Chart("myChart3", {
    //     type: "line",
    //     data: {
    //         labels: appSetting.requests_by_year.series.name,
    //         datasets: [
    //             {
    //                 label: appSetting.requests_by_year.name,
    //                 data: appSetting.requests_by_year.series.value,
    //                 borderWidth: 2,
    //                 backgroundColor: "#00533e",
    //             },
    //         ],
    //     },
    //     options: {
    //         scales: {
    //             y: {
    //                 beginAtZero: true,
    //             },
    //         },
    //     },
    // });

    // new Chart("myChart4", {
    //     type: "line",
    //     data: {
    //         labels: ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    //         datasets: [
    //             {
    //                 label: "Nombre de PME/PMI accompagnées",
    //                 data: [12, 19, 3, 5, 2, 3, 50],
    //                 borderWidth: 2,
    //                 backgroundColor: "#00533e",
    //             },
    //         ],
    //     },
    //     options: {
    //         scales: {
    //             y: {
    //                 beginAtZero: true,
    //             },
    //         },
    //     },
    // });

    new Chart("myChart5", {
      type: "line",
      data: {
        labels: ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
        datasets: [
          {
            label: "Nombre de mises en relation",
            data: [12, 19, 3, 5, 2, 3, 50],
            borderWidth: 2,
            backgroundColor: "#00533e",
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });

    // new Chart("myChart6", {
    //     type: "line",
    //     data: {
    //         labels: ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    //         datasets: [
    //             {
    //                 label: "Nombre de PME/PMI contractualisées",
    //                 data: [12, 19, 3, 5, 2, 3, 50],
    //                 borderWidth: 2,
    //                 backgroundColor: "#00533e",
    //             },
    //         ],
    //     },
    //     options: {
    //         scales: {
    //             y: {
    //                 beginAtZero: true,
    //             },
    //         },
    //     },
    // });
    new Chart("myChart7", {
      type: "line",
      data: {
        labels: appSetting.buyers_by_year.series.name,
        datasets: [
          {
            label: appSetting.buyers_by_year.name,
            data: appSetting.buyers_by_year.series.value,
            borderWidth: 2,
            backgroundColor: "#00533e",
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
    // new Chart("myChart8", {
    //     type: "line",
    //     data: {
    //         labels: ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    //         datasets: [
    //             {
    //                 label: "Nombre total de contrats",
    //                 data: [12, 19, 3, 5, 2, 3, 50],
    //                 borderWidth: 2,
    //                 backgroundColor: "#00533e",
    //             },
    //         ],
    //     },
    //     options: {
    //         scales: {
    //             y: {
    //                 beginAtZero: true,
    //             },
    //         },
    //     },
    // });
    new Chart("myChart9", {
      type: "line",

      data: {
        labels: ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],

        datasets: [
          {
            label: "Montant total des contrats (En milliards de GNF)",
            data: [12, 19, 3, 5, 2, 3, 50],
            borderWidth: 2,
            backgroundColor: "#00533e",
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
  }

  ngOnInit(): void {
    // $.getScript('assets/js/custom.js')
    this.target = this.appSettingService.value.total_supplier;
    this.target1 = this.appSettingService.value.total_request;
    // this.target = this.appSettingService.value.total_buyer;
    // this.target = this.appSettingService.value.total_supplier;
    // this.startCounting();
    // this.startCounting1();

    setTimeout(() => this.getStats(this.appSettingService.value), 1000);

    this.setMetaTags();

    // Initialiser les animations après un délai pour s'assurer que le DOM est prêt
    setTimeout(() => {
      this.observeElements();
      this.addParallaxEffect();
      this.addAdvancedHoverEffects();
      this.animateIcons();
      this.createParticleEffect();
    }, 1000);

    if (this.authService.value != null) {
      if (this.authService.isAuthenticated()) {
        const authToken = this.jwtHelper.decodeToken();
        if (authToken.role == "supplier") {
          this.router.navigate(["/supplier/dashboard"]);
        } else if (authToken.role == "buyer") {
          this.router.navigate(["/buyer/dashboard"]);
        }
      }
    }

    this.articleService
      .limit()
      .pipe(
        retryWhen((errors) =>
          errors.pipe(
            mergeMap((error) => {
              // Si c'est une erreur serveur (500+), on réessaie après un délai
              if (error.status >= 500) {
                console.log("Erreur serveur, nouvelle tentative...");
                return of(error).pipe(delay(500));
              }
              // Sinon (404, 400, etc.), on propage immédiatement l'erreur
              return throwError(() => error);
            }),
            take(3) // Max 3 tentatives pour les erreurs 5xx
          )
        )
      )
      .subscribe({
        next: (response) => {
          this.articles = response;
        },
        error: (error) => {},
      });

    this.serviceService
      .list()
      .pipe(
        retryWhen((errors) =>
          errors.pipe(
            mergeMap((error) => {
              // Si c'est une erreur serveur (500+), on réessaie après un délai
              if (error.status >= 500) {
                console.log("Erreur serveur, nouvelle tentative...");
                return of(error).pipe(delay(500));
              }
              // Sinon (404, 400, etc.), on propage immédiatement l'erreur
              return throwError(() => error);
            }),
            take(3) // Max 3 tentatives pour les erreurs 5xx
          )
        )
      )
      .subscribe({
        next: (response) => {
          this.services = response;
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
        },
      });
  }

  private setMetaTags() {
    const siteUrl = "https://bstpgn.com";
    const pageTitle = "BSTP Guinée - Accueil";
    const pageDescription =
      "A propos de nous - Description détaillée pour les réseaux sociaux.";
    const imageUrl = `${siteUrl}/assets/img/upload/slides/img-1.webp`; // Chemin vers votre image (1200x630px recommandé)

    // Balises standards (SEO)
    this.meta.updateTag({ name: "description", content: pageDescription });
    this.meta.updateTag({
      name: "keywords",
      content: "BSTP Guinée, BSTP, bstpgn",
    });
    this.meta.updateTag({ name: "author", content: "BSTP Guinée" });

    // Open Graph (Facebook, WhatsApp, LinkedIn, etc.)
    this.meta.updateTag({ property: "og:type", content: "website" });
    this.meta.updateTag({ property: "og:url", content: siteUrl });
    this.meta.updateTag({ property: "og:title", content: pageTitle });
    this.meta.updateTag({
      property: "og:description",
      content: pageDescription,
    });
    this.meta.updateTag({ property: "og:image", content: imageUrl });
    this.meta.updateTag({ property: "og:image:width", content: "1200" });
    this.meta.updateTag({ property: "og:image:height", content: "630" });

    // Twitter Card
    this.meta.updateTag({
      name: "twitter:card",
      content: "summary_large_image",
    });
    this.meta.updateTag({ name: "twitter:title", content: pageTitle });
    this.meta.updateTag({
      name: "twitter:description",
      content: pageDescription,
    });
    this.meta.updateTag({ name: "twitter:image", content: imageUrl });
  }

  format(value) {
    return numberWithSpaces(value);
  }

  startState(value: number) {
    return startCounting(value);
  }

  // Méthode pour animer les compteurs
  animateCounters() {
    const counters = document.querySelectorAll('.counter-number');
    
    counters.forEach((counter) => {
      const target = parseInt(counter.getAttribute('data-target') || '0');
      const increment = target / 100;
      let current = 0;
      
      const updateCounter = () => {
        if (current < target) {
          current += increment;
          counter.textContent = '+' + Math.ceil(current).toLocaleString();
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = '+' + target.toLocaleString();
        }
      };
      
      updateCounter();
    });
  }

  // Méthode pour animer le texte typewriter
  animateTypewriter() {
    const typewriterElements = document.querySelectorAll('.typewriter-text');
    
    typewriterElements.forEach((element) => {
      const text = element.textContent || '';
      element.textContent = '';
      
      let i = 0;
      const typeWriter = () => {
        if (i < text.length) {
          element.textContent += text.charAt(i);
          i++;
          setTimeout(typeWriter, 100);
        }
      };
      
      typeWriter();
    });
  }

  // Méthode pour observer les éléments et déclencher les animations
  observeElements() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          
          // Si c'est un compteur, animer le compteur
          if (entry.target.classList.contains('animated-counter')) {
            this.animateCounters();
          }
          
          // Si c'est un texte typewriter, animer le texte
          if (entry.target.querySelector('.typewriter-text')) {
            this.animateTypewriter();
          }
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    // Observer tous les éléments avec des animations
    const animatedElements = document.querySelectorAll('.animated-counter, .interactive-card, .animated-title, .animated-description');
    animatedElements.forEach((element) => {
      observer.observe(element);
    });
  }

  // Méthode pour ajouter des effets de parallaxe
  addParallaxEffect() {
    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      const parallaxElements = document.querySelectorAll('.parallax');
      
      parallaxElements.forEach((element) => {
        if (element instanceof HTMLElement) {
          const speed = element.getAttribute('data-speed') || '0.5';
          const yPos = -(scrolled * parseFloat(speed));
          element.style.transform = `translateY(${yPos}px)`;
        }
      });
    });
  }

  // Méthode pour ajouter des effets de hover avancés
  addAdvancedHoverEffects() {
    const cards = document.querySelectorAll('.interactive-card, .value-card, .advantage-card, .testimonial-card, .sector-card, .partner-card');
    
    cards.forEach((card) => {
      if (card instanceof HTMLElement) {
        card.addEventListener('mouseenter', (e: MouseEvent) => {
          const rect = card.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          
          card.style.setProperty('--mouse-x', `${x}px`);
          card.style.setProperty('--mouse-y', `${y}px`);
          card.classList.add('hover-active');
        });
        
        card.addEventListener('mouseleave', () => {
          card.classList.remove('hover-active');
        });
      }
    });
  }

  // Méthode pour animer les icônes
  animateIcons() {
    const icons = document.querySelectorAll('.counter-icon, .value-icon, .advantage-icon, .sector-icon, .partner-icon');
    
    icons.forEach((icon, index) => {
      setTimeout(() => {
        icon.classList.add('animate-icon');
      }, index * 200);
    });
  }

  // Méthode pour créer des effets de particules
  createParticleEffect() {
    const ctaSection = document.querySelector('.final-cta-area');
    if (ctaSection) {
      for (let i = 0; i < 50; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        particle.style.left = Math.random() * 100 + '%';
        particle.style.animationDelay = Math.random() * 3 + 's';
        particle.style.animationDuration = (Math.random() * 3 + 2) + 's';
        ctaSection.appendChild(particle);
      }
    }
  }
}
